module.exports = __webpack_public_path__ + "img/7a5f7a13c3cff3b76bd47bcaf2932f32.png";